import Vue from 'vue';
import xss, { getDefaultWhiteList } from 'xss';

// Get the default whitelist and extend it
const defaultWhiteList = getDefaultWhiteList();

// Create custom whitelist with "class" added to img tags
const customWhiteList = {
  ...defaultWhiteList,
  img: [...(defaultWhiteList.img || []), 'class']
};

// Export the XSS options
export const xssOptions = {
  whiteList: customWhiteList
};

// Export a convenience function
export function sanitizeHtml(html: string, options: any = {}) {
  return xss(html, { ...xssOptions, ...options });
}

// Vue plugin
export default {
  install(Vue: any) {
    // Add global method
    Vue.prototype.$sanitizeHtml = sanitizeHtml;
    
    // Add global property
    Vue.prototype.$xssOptions = xssOptions;
    
    // Add global filter
    Vue.filter('sanitize', sanitizeHtml);
  }
};

// TypeScript declarations
declare module 'vue/types/vue' {
  interface Vue {
    $sanitizeHtml(html: string, options?: any): string;
    $xssOptions: any;
  }
}
